import React, { Component } from "react";
import { Table, Button, Row, Col, Tooltip } from "antd";
import axios from "axios";
import PrintModalSemCab from '../components/PrintModalSemCab';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";
import { getUsuario } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import { maskCNPJ, maskCPF } from "../utils/Masker";
import { resolveImageUrl } from '../utils/Storage';

const { Column } = Table;

class OSReduzidaPrintModal extends Component {
    state = {
        registro: [],
        os_idf: 0,
        listaProdutos: [],
        listaParcelas: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        // console.log('OSReduzidaPrintModal - componentDidUpdate - this.props: ', this.props);
        // console.log('OSReduzidaPrintModal - componentDidUpdate - propsAnte: ', propsAnte);
        if ((this.props.visivel !== propsAnte.visivel) && (this.props.os_idf)) {
            // console.log('OSReduzidaPrintModal - componentDidUpdate - 2222222');
            this.setState({
                os_idf: this.props.os_idf,
                registro: [],
                visualizar: true,
            });
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { os_idf } = this.props;

        axios
            .get(`/ordem_servicos/show/${os_idf}`)
            .then(response => {
                const { data } = response;

                // console.log('getListaRegistros: ', data);

                let listaProdutos = [];
                let listaParcelas = [];

                for (var x in data.listaProdutos) {
                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_idf: data.listaProdutos[x].mi_idf,
                        mi_item: data.listaProdutos[x].mi_item,
                        mi_servico: { key: '0' },
                        mi_item_Avulso: '',
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: data.listaProdutos[x].prod_idf,
                        pest_qtde: data.listaProdutos[x].pest_qtde,
                        prod_grade: data.listaProdutos[x].prod_grade,
                        mi_item_tamanho: data.listaProdutos[x].mi_item_tamanho,
                        mi_item_cor: data.listaProdutos[x].mi_item_cor,
                        ptam_descricao: data.listaProdutos[x].ptam_descricao,
                        pcor_descricao: data.listaProdutos[x].pcor_descricao,
                        prod_codigo: data.listaProdutos[x].prod_codigo,
                        prod_descricao: data.listaProdutos[x].prod_descricao,
                        prod_cod_barras: data.listaProdutos[x].prod_cod_barras,
                        mi_qtde: parseFloat(data.listaProdutos[x].mi_qtde),
                        mi_vlr_unit: parseFloat(data.listaProdutos[x].mi_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaProdutos[x].mi_vlr_venda),
                        mi_vlr_venda_min: parseFloat(data.listaProdutos[x].mi_vlr_venda_min),
                        mi_perc_desc: parseFloat(data.listaProdutos[x].mi_perc_desc),
                        mi_vlr_desc: parseFloat(data.listaProdutos[x].mi_vlr_desc),
                        mi_vlr_acres: parseFloat(data.listaProdutos[x].mi_vlr_acres),
                        mi_vlr_total: parseFloat(data.listaProdutos[x].mi_vlr_total),
                        mi_calc_estoque: parseFloat(data.listaProdutos[x].mi_calc_estoque),
                        tipoItem: 'P',
                    });
                };

                for (var x in data.listaServicos) {
                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_idf: data.listaServicos[x].osis_idf,
                        mi_item: { key: '0' },
                        mi_servico: data.listaServicos[x].osis_servico,
                        mi_item_Avulso: '',
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: '',
                        pest_qtde: 0,
                        prod_grade: '',
                        mi_item_tamanho: '',
                        mi_item_cor: '',
                        ptam_descricao: '',
                        pcor_descricao: '',
                        prod_codigo: '',
                        prod_descricao: data.listaServicos[x].serv_descricao,
                        prod_cod_barras: '',
                        mi_qtde: parseFloat(data.listaServicos[x].osis_qtde),
                        mi_vlr_unit: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_vlr_venda_min: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_perc_desc: 0,
                        mi_vlr_desc: 0,
                        mi_vlr_acres: 0,
                        mi_vlr_total: parseFloat(data.listaServicos[x].osis_vlr_total),
                        mi_calc_estoque: 0,
                        tipoItem: 'S',
                    });
                };

                for (var x in data.listaAvulsos) {
                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_idf: data.listaAvulsos[x].osia_idf,
                        mi_item: { key: '0' },
                        mi_servico: 0,
                        mi_item_Avulso: data.listaAvulsos[x].osia_descricao,
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: '',
                        pest_qtde: 0,
                        prod_grade: '',
                        mi_item_tamanho: '',
                        mi_item_cor: '',
                        ptam_descricao: '',
                        pcor_descricao: '',
                        prod_codigo: '',
                        prod_descricao: data.listaAvulsos[x].osia_descricao,
                        prod_cod_barras: '',
                        mi_qtde: parseFloat(data.listaAvulsos[x].osia_qtde),
                        mi_vlr_unit: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_vlr_venda_min: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_perc_desc: 0,
                        mi_vlr_desc: 0,
                        mi_vlr_acres: 0,
                        mi_vlr_total: parseFloat(data.listaAvulsos[x].osia_vlr_total),
                        mi_calc_estoque: 0,
                        tipoItem: 'A',
                    });
                };

                for (var x in data.listaParcelas) {
                    listaParcelas.push({
                        tparc_parcela: data.listaParcelas[x].tparc_parcela,
                        tparc_data_parcela: data.listaParcelas[x].tparc_data_parcela,
                        tparc_valor: data.listaParcelas[x].tparc_valor,
                    });
                };

                this.setState({
                    registro: data.dados,
                    listaProdutos: listaProdutos,
                    listaParcelas: listaParcelas,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            ven_idf: 0,
            registro: [],
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderTipoItem = (tipo) => {
        return (
            <span> {tipo === 'P' ? 'Produto' : (tipo === 'S' ? 'Serviço' : 'Avulso')} </span>
        );
    };

    renderDescrProduto = (prod_descricao, registro) => {
        return (
            <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }

    renderPagto = (listaParcelas, registro) => {
        let descrPagto = '';

        // console.log('renderPagto: ', listaParcelas);

        for (var x in listaParcelas) {
            descrPagto = descrPagto + ' *** ' + moment(listaParcelas[x].tparc_data_parcela).format('DD/MM/YYYY') + ' - ' + numeral(parseFloat(listaParcelas[x].tparc_valor)).format('0,000.00');
        };
        return (
            <span> {descrPagto} </span>
        );
    };

    renderCheckList = (checkListSelect, registro) => {
        let descrChecList = '';

        // console.log('renderCheckList: ', checkListSelect);

        for (var x in checkListSelect) {
            descrChecList = descrChecList + checkListSelect[x].clos_descricao + '  /  ';
        };
        return (
            <span> {descrChecList} </span>
        );
    };




    render() {
        const { onCancelarPrintClick, visivel } = this.props;
        const { carregando, visualizar, listaProdutos, listaParcelas } = this.state;
        const { os_numero, os_data_emissao, ven_pessoa, pes_codigo, pes_nome, usu_nome,
            pes_fone1, pes_fone2, pes_fone3,
            os_descricao, os_solicitante, oso_defeitos, oso_laudo, checkListSelect } = this.state.registro;

        const usuario = getUsuario();

        // console.log('OSReduzidaPrintModal: ', this.state);

        return (
            <span style={{}}>
                <PrintModalSemCab
                    visible={visivel}
                    onCancel={onCancelarPrintClick}
                >

                    <Row className="bordaExternaOS2Vias">
                        <Row className="bordaInternaOS2Vias">
                            {usuario.emp_logo ? (
                                <div style={{ float: "right", margin: 5 }}>
                                    <img
                                        src={usuario.emp_logo ? resolveImageUrl(`imagens/emp${usuario.emp_codigo}.${usuario.emp_logo}`) : ''}
                                        resizeMode="contain"
                                        style={{ height: 60, width: 60 }}
                                    />
                                </div>
                            ) : null}

                            <div style={{ float: "left", margin: 5 }}>
                                <div>
                                    <span className="nome-empresa">
                                        {usuario.emp_nome}
                                    </span>
                                </div>
                                <div>
                                    <span className="dados-empresa">
                                        {!usuario.emp_cpf_cnpj ? '' : usuario.emp_cpf_cnpj.length === 11 ? maskCPF(usuario.emp_cpf_cnpj) : maskCNPJ(usuario.emp_cpf_cnpj)}
                                        {usuario.emp_fone1 ? ' - ' + usuario.emp_fone1 : ''}
                                        {usuario.emp_fone2 ? ' - ' + usuario.emp_fone2 : ''}
                                        {usuario.emp_fone3 ? ' - ' + usuario.emp_fone3 : ''}
                                    </span>
                                </div>
                                <div>
                                    <span className="dados-empresa">
                                        {usuario.emp_endereco ? usuario.emp_endereco : ''}
                                        {usuario.emp_numero ? ' nº ' + usuario.emp_numero : ''}
                                        {usuario.emp_complemento ? ' ' + usuario.emp_complemento : ''}
                                        {usuario.emp_bairro ? ' - ' + usuario.emp_bairro : ''}
                                        {usuario.cmun_descricao ? ' - ' + usuario.cmun_descricao : ''}
                                        {usuario.cuf_sigla ? ' - ' + usuario.cuf_sigla : ''}
                                    </span>
                                </div>
                            </div>
                        </Row>

                        <Row className="bordaInternaOS2Vias">
                            <Col xs={12}>
                                <span style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "grey", marginLeft: 10 }}>ORDEM DE SERVIÇO</span>
                            </Col>
                            <Col xs={4}>
                                <span style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "grey" }}>Nº: </span>
                                <span style={{ textAlign: "center", fontSize: 20, color: "grey" }}> {os_numero} </span>
                            </Col>
                            <Col xs={8} style={{ paddingTop: 5 }}>
                                <span style={{ textAlign: "center", fontSize: 15, fontWeight: "bold", color: "grey" }}>Emissão: </span>
                                <span style={{ textAlign: "center", fontSize: 15, color: "grey" }}> {this.renderData(os_data_emissao)} </span>
                            </Col>
                        </Row>

                        <Row className="bordaInternaOS2Vias" style={{ height: 140 }}>
                            <Col xs={12}>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Cliente:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{pes_codigo + ' - ' + pes_nome + ' - ' + os_solicitante}</span>
                                    {(pes_fone1 !== '' || pes_fone2 !== '' || pes_fone3 !== '') && (pes_fone1 !== '(  )      -' || pes_fone2 !== '(  )      -' || pes_fone3 !== '(  )      -') ? (
                                        <span>
                                            <span> {pes_fone1 !== '' && pes_fone1 !== '(  )      -' ? ' - ' + pes_fone1 : ''} </span>
                                            <span> {pes_fone2 !== '' && pes_fone2 !== '(  )      -' ? ' - ' + pes_fone2 : ''} </span>
                                            <span> {pes_fone3 !== '' && pes_fone3 !== '(  )      -' ? ' - ' + pes_fone3 : ''} </span>
                                        </span>
                                    ) : null}
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Descrição:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{os_descricao}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Vendedor:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{usu_nome}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Pagto:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{this.renderPagto(listaParcelas)}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>CheckList:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{this.renderCheckList(checkListSelect)}</span>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{ height: 70 }}>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Defeitos Relatados:</span>
                                    </div>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{oso_defeitos}</span>
                                    </div>
                                </div>
                                <div style={{ height: 70 }}>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Laudo Técnico:</span>
                                    </div>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{oso_laudo}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="bordaInternaOS2Vias" style={{ height: 180 }}>
                            <Table
                                pagination={false}
                                dataSource={listaProdutos}
                                // className="tabela"
                                rowKey={(listaRegistros => listaRegistros.mi_idf)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="tipoItem"
                                    dataIndex="tipoItem"
                                    title="Tipo Item"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                    render={this.renderTipoItem}
                                />
                                <Column
                                    key="prod_codigo"
                                    dataIndex="prod_codigo"
                                    title="Código"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="prod_descricao"
                                    dataIndex="prod_descricao"
                                    title="Descrição"
                                    width={200}
                                    align="left"
                                    className="listaCadastro"
                                    render={this.renderDescrProduto}
                                />
                                <Column
                                    key="mi_qtde"
                                    dataIndex="mi_qtde"
                                    title="Qtde"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_unit"
                                    dataIndex="mi_vlr_unit"
                                    title="Vlr Unit"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_desc"
                                    dataIndex="mi_vlr_desc"
                                    title="Vlr Desc"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_total"
                                    dataIndex="mi_vlr_total"
                                    title="Vlr Total"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>

                        <Row style={{ marginTop: 10, marginBottom: 0 }}>
                            <Col xs={12}>
                                <div style={{ textAlign: 'center', fontSize: 10 }}>
                                    <span>------------------------------</span>
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 10, marginTop: -8 }}>
                                    <span>Responsável</span>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{ textAlign: 'center', fontSize: 10 }}>
                                    <span>------------------------------</span>
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 10, marginTop: -8 }}>
                                    <span>Cliente</span>
                                </div>
                            </Col>
                        </Row>

                        <Row style={{ padding: 3, height: 40 }}>
                            <div className="textoTermosOS2Vias">
                                {usuario.par_termos_os}
                            </div>
                            {/* <div className="textoTermosOS2Vias" style={{}}>
                                AO ASSINAR ESTA ORDEM DE SERVIÇO VOCÊ ESTARÁ CONCORDANDO COM OS SEGUINTES TERMOS:
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [1] O Aparelho só poderá ser retirado mediante a apresentação desta O.S., ou, pelo próprio solicitante mediante apresentação de documentos pessoais, SEM EXCEÇÕES;
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [2] O prazo máximo para a retirada do aparelho é de 90 dias após a abertura desta O.S. Após este período seu aparelho seguirá para descarte, prerrogativa esta embasada por lei.
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [3] O prazo de entraga informado pode ser alterado sem aviso prévio devido a atrasos de entrega por terceiros (quando uma encomenda for necessária) ou complicações durante reparo.
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [4] O serviço terá garantia de 90 dias e cobrirá apenas defeitos de fabricação no componente substituído, quando não houver constatação de mau uso por parte do cliente, umidade, dano físico ou abertura que não tenha sido feita por esta assistência. Defeitos que o aparelho possavir a apresentar durante período de garantia e que não forem relacionados ao serviço realizado por esta assistência não estarão cobertos por garantia.
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [5] A assistência não se responsabiliza por eventuais perdas de dados pessoais contidos no aparelho em decorrência do procedimento de reparo.
                            </div> */}

                            {/* <div className="textoTermosOS2Vias" style={{}}>
                                Garantias
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                1° NÃO nos responsabilizamos por dados do celular como: agenda, fotos, videos, etc,
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                2° 7 (sete) dias para reclamações e devoluções, 90 (noventa) dias de garantia para o serviço,
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                3° NÃO haverá garantia em casos de: QUEDAS, OXIDAÇÕES ou MAU USO.
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                Prazos
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                1° O consumidor autoriza prévia e expressamente a doação para uma entidade de caridade daquele produto caso ele não seja retirado dentro de determinado prazo, isto nos casos em que o serviço tiver sido pago antecipadamente,
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                2° O consumidor autoriza prévia e expressamente a venda do produto para o pagamento dos serviços efetuados, tendo direito ao recebimento de eventual saldo positivo ou tenda o dever de efetuar o pagamento da diferença restante conforme o valor apurado com a vonda do produto e o seu débito,
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                3° Aparelhos não retirados em até 3 meses (90 dias), serdo sucateados ou vendidos
                            </div> */}

                            {/* <span className="textoTermosOS2Vias" style={{}}>
                                Garantias
                                1° NÃO nos responsabilizamos por dados do celular como: agenda, fotos, videos, etc,
                                2° 7 (sete) dias para reclamações e devoluções, 90 (noventa) dias de garantia para o serviço,
                                3° NÃO haverá garantia em casos de: QUEDAS, OXIDAÇÕES ou MAU USO.

                                Prazos
                                1° O consumidor autoriza prévia e expressamente a doação para uma entidade de caridade daquele produto caso ele não seja retirado dentro de determinado prazo, isto nos casos em que o serviço tiver sido pago antecipadamente,
                                2° O consumidor autoriza prévia e expressamente a venda do produto para o pagamento dos serviços efetuados, tendo direito ao recebimento de eventual saldo positivo ou tenda o dever de efetuar o pagamento da diferença restante conforme o valor apurado com a vonda do produto e o seu débito,
                                3° Aparelhos não retirados em até 3 meses (90 dias), serdo sucateados ou vendidos
                            </span> */}
                        </Row>

                    </Row>








                    <Row className="bordaExternaOS2Vias" style={{ marginTop: 30 }}>
                        <Row className="bordaInternaOS2Vias">
                            {usuario.emp_logo ? (
                                <div style={{ float: "right", margin: 5 }}>
                                    <img
                                        src={usuario.emp_logo ? resolveImageUrl(`imagens/emp${usuario.emp_codigo}.${usuario.emp_logo}`) : ''}
                                        resizeMode="contain"
                                        style={{ height: 60, width: 60 }}
                                    />
                                </div>
                            ) : null}

                            <div style={{ float: "left", margin: 5 }}>
                                <div>
                                    <span className="nome-empresa">
                                        {usuario.emp_nome}
                                    </span>
                                </div>
                                <div>
                                    <span className="dados-empresa">
                                        {!usuario.emp_cpf_cnpj ? '' : usuario.emp_cpf_cnpj.length === 11 ? maskCPF(usuario.emp_cpf_cnpj) : maskCNPJ(usuario.emp_cpf_cnpj)}
                                        {usuario.emp_fone1 ? ' - ' + usuario.emp_fone1 : ''}
                                        {usuario.emp_fone2 ? ' - ' + usuario.emp_fone2 : ''}
                                        {usuario.emp_fone3 ? ' - ' + usuario.emp_fone3 : ''}
                                    </span>
                                </div>
                                <div>
                                    <span className="dados-empresa">
                                        {usuario.emp_endereco ? usuario.emp_endereco : ''}
                                        {usuario.emp_numero ? ' nº ' + usuario.emp_numero : ''}
                                        {usuario.emp_complemento ? ' ' + usuario.emp_complemento : ''}
                                        {usuario.emp_bairro ? ' - ' + usuario.emp_bairro : ''}
                                        {usuario.cmun_descricao ? ' - ' + usuario.cmun_descricao : ''}
                                        {usuario.cuf_sigla ? ' - ' + usuario.cuf_sigla : ''}
                                    </span>
                                </div>
                            </div>
                        </Row>

                        <Row className="bordaInternaOS2Vias">
                            <Col xs={12}>
                                <span style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "grey", marginLeft: 10 }}>ORDEM DE SERVIÇO</span>
                            </Col>
                            <Col xs={4}>
                                <span style={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "grey" }}>Nº: </span>
                                <span style={{ textAlign: "center", fontSize: 20, color: "grey" }}> {os_numero} </span>
                            </Col>
                            <Col xs={8} style={{ paddingTop: 5 }}>
                                <span style={{ textAlign: "center", fontSize: 15, fontWeight: "bold", color: "grey" }}>Emissão: </span>
                                <span style={{ textAlign: "center", fontSize: 15, color: "grey" }}> {this.renderData(os_data_emissao)} </span>
                            </Col>
                        </Row>

                        <Row className="bordaInternaOS2Vias" style={{ height: 140 }}>
                            <Col xs={12}>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Cliente:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{pes_codigo + ' - ' + pes_nome + ' - ' + os_solicitante}</span>
                                    {(pes_fone1 !== '' || pes_fone2 !== '' || pes_fone3 !== '') && (pes_fone1 !== '(  )      -' || pes_fone2 !== '(  )      -' || pes_fone3 !== '(  )      -') ? (
                                        <span>
                                            <span> {pes_fone1 !== '' && pes_fone1 !== '(  )      -' ? ' - ' + pes_fone1 : ''} </span>
                                            <span> {pes_fone2 !== '' && pes_fone2 !== '(  )      -' ? ' - ' + pes_fone2 : ''} </span>
                                            <span> {pes_fone3 !== '' && pes_fone3 !== '(  )      -' ? ' - ' + pes_fone3 : ''} </span>
                                        </span>
                                    ) : null}
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Descrição:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{os_descricao}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Vendedor:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{usu_nome}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Pagto:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{this.renderPagto(listaParcelas)}</span>
                                </div>
                                <div>
                                    <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>CheckList:</span>
                                    <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{this.renderCheckList(checkListSelect)}</span>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{ height: 70 }}>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Defeitos Relatados:</span>
                                    </div>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{oso_defeitos}</span>
                                    </div>
                                </div>
                                <div style={{ height: 70 }}>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 15, color: "grey", marginLeft: 10, fontWeight: "bold" }}>Laudo Técnico:</span>
                                    </div>
                                    <div>
                                        <span style={{ textAlign: "center", fontSize: 12, color: "grey", marginLeft: 10 }}>{oso_laudo}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="bordaInternaOS2Vias" style={{ height: 180 }}>
                            <Table
                                pagination={false}
                                dataSource={listaProdutos}
                                // className="tabela"
                                rowKey={(listaRegistros => listaRegistros.mi_idf)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="tipoItem"
                                    dataIndex="tipoItem"
                                    title="Tipo Item"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                    render={this.renderTipoItem}
                                />
                                <Column
                                    key="prod_codigo"
                                    dataIndex="prod_codigo"
                                    title="Código"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="prod_descricao"
                                    dataIndex="prod_descricao"
                                    title="Descrição"
                                    width={200}
                                    align="left"
                                    className="listaCadastro"
                                    render={this.renderDescrProduto}
                                />
                                <Column
                                    key="mi_qtde"
                                    dataIndex="mi_qtde"
                                    title="Qtde"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_unit"
                                    dataIndex="mi_vlr_unit"
                                    title="Vlr Unit"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_desc"
                                    dataIndex="mi_vlr_desc"
                                    title="Vlr Desc"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="mi_vlr_total"
                                    dataIndex="mi_vlr_total"
                                    title="Vlr Total"
                                    render={this.renderValor}
                                    width={60}
                                    align="right"
                                    className="listaCadastro"
                                />
                            </Table>
                        </Row>

                        <Row style={{ marginTop: 10, marginBottom: 0 }}>
                            <Col xs={12}>
                                <div style={{ textAlign: 'center', fontSize: 10 }}>
                                    <span>------------------------------</span>
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 10, marginTop: -8 }}>
                                    <span>Responsável</span>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div style={{ textAlign: 'center', fontSize: 10 }}>
                                    <span>------------------------------</span>
                                </div>
                                <div style={{ textAlign: 'center', fontSize: 10, marginTop: -8 }}>
                                    <span>Cliente</span>
                                </div>
                            </Col>
                        </Row>

                        <Row style={{ padding: 3, height: 40 }}>
                            <div className="textoTermosOS2Vias" style={{}}>
                                {usuario.par_termos_os}
                            </div>

                            {/* <div className="textoTermosOS2Vias" style={{}}>
                                AO ASSINAR ESTA ORDEM DE SERVIÇO VOCÊ ESTARÁ CONCORDANDO COM OS SEGUINTES TERMOS:
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [1] O Aparelho só poderá ser retirado mediante a apresentação desta O.S., ou, pelo próprio solicitante mediante apresentação de documentos pessoais, SEM EXCEÇÕES;
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [2] O prazo máximo para a retirada do aparelho é de 90 dias após a abertura desta O.S. Após este período seu aparelho seguirá para descarte, prerrogativa esta embasada por lei.
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [3] O prazo de entraga informado pode ser alterado sem aviso prévio devido a atrasos de entrega por terceiros (quando uma encomenda for necessária) ou complicações durante reparo.
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [4] O serviço terá garantia de 90 dias e cobrirá apenas defeitos de fabricação no componente substituído, quando não houver constatação de mau uso por parte do cliente, umidade, dano físico ou abertura que não tenha sido feita por esta assistência. Defeitos que o aparelho possavir a apresentar durante período de garantia e que não forem relacionados ao serviço realizado por esta assistência não estarão cobertos por garantia.
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                [5] A assistência não se responsabiliza por eventuais perdas de dados pessoais contidos no aparelho em decorrência do procedimento de reparo.
                            </div> */}

                            {/* <div className="textoTermosOS2Vias" style={{}}>
                                Garantias
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                1° NÃO nos responsabilizamos por dados do celular como: agenda, fotos, videos, etc,
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                2° 7 (sete) dias para reclamações e devoluções, 90 (noventa) dias de garantia para o serviço,
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                3° NÃO haverá garantia em casos de: QUEDAS, OXIDAÇÕES ou MAU USO.
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                Prazos
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                1° O consumidor autoriza prévia e expressamente a doação para uma entidade de caridade daquele produto caso ele não seja retirado dentro de determinado prazo, isto nos casos em que o serviço tiver sido pago antecipadamente,
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                2° O consumidor autoriza prévia e expressamente a venda do produto para o pagamento dos serviços efetuados, tendo direito ao recebimento de eventual saldo positivo ou tenda o dever de efetuar o pagamento da diferença restante conforme o valor apurado com a vonda do produto e o seu débito,
                            </div>
                            <div className="textoTermosOS2Vias" style={{}}>
                                3° Aparelhos não retirados em até 3 meses (90 dias), serdo sucateados ou vendidos
                            </div> */}

                            {/* <span className="textoTermosOS2Vias" style={{}}>
                                Garantias
                                1° NÃO nos responsabilizamos por dados do celular como: agenda, fotos, videos, etc,
                                2° 7 (sete) dias para reclamações e devoluções, 90 (noventa) dias de garantia para o serviço,
                                3° NÃO haverá garantia em casos de: QUEDAS, OXIDAÇÕES ou MAU USO.

                                Prazos
                                1° O consumidor autoriza prévia e expressamente a doação para uma entidade de caridade daquele produto caso ele não seja retirado dentro de determinado prazo, isto nos casos em que o serviço tiver sido pago antecipadamente,
                                2° O consumidor autoriza prévia e expressamente a venda do produto para o pagamento dos serviços efetuados, tendo direito ao recebimento de eventual saldo positivo ou tenda o dever de efetuar o pagamento da diferença restante conforme o valor apurado com a vonda do produto e o seu débito,
                                3° Aparelhos não retirados em até 3 meses (90 dias), serdo sucateados ou vendidos
                            </span> */}

                            {/* <span className="textoTermosOS2Vias" style={{}}>
                                AO ASSINAR ESTA ORDEM DE SERVIÇO VOCÊ ESTARÁ CONCORDANDO COM OS SEGUINTES TERMOS:
                                [1] O Aparelho só poderá ser retirado mediante a apresentação desta O.S., ou, pelo próprio solicitante mediante apresentação de documentos pessoais, SEM EXCEÇÕES;
                                [2] O prazo máximo para a retirada do aparelho é de 90 dias após a abertura desta O.S. Após este período seu aparelho seguirá para descarte, prerrogativa esta embasada por lei.
                                [3] O prazo de entraga informado pode ser alterado sem aviso prévio devido a atrasos de entrega por terceiros (quando uma encomenda for necessária) ou complicações durante reparo.
                                [4] O serviço terá garantia de 90 dias e cobrirá apenas defeitos de fabricação no componente substituído, quando não houver constatação de mau uso por parte do cliente, umidade, dano físico ou abertura que não tenha sido feita por esta assistência. Defeitos que o aparelho possavir a apresentar durante período de garantia e que não forem relacionados ao serviço realizado por esta assistência não estarão cobertos por garantia.
                                [5] A assistência não se responsabiliza por eventuais perdas de dados pessoais contidos no aparelho em decorrência do procedimento de reparo.
                            </span> */}
                        </Row>

                    </Row>




                </PrintModalSemCab>
            </span >
        );
    }
}

export default OSReduzidaPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/OSReduzidaPrintModal.js